// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__295mj","question":"Question_question__1UCx8","description":"Question_description__2TKA9"};